<template>
  <div>
    <table class="striped responsive-table tbgrid" style="width: 100%">
      <tbody>
        <tr>
          <td valign="top" style="width: 50%; vertical-align: top">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <md-field>
                  <vue-select
                    class="vue-select2"
                    name="select2"
                    :options="items"
                    :onChange="change_cliente"
                    :searchable="true"
                    language="pt-BR"
                  >
                  </vue-select>
                </md-field>
              </div>
            </div>

            <!--  v-model="id_start_value"  :onSelect="selected_unidades" show_carregando -->
            <checkbox_list
              v-if="show_unidades"
              field_value="id"
              field_text="nome"
              v-model="ids_unidades"
              :show_carregando="loading_unidades"
              :items="list_unidades"
              :id_not_in="id_start_value"
            ></checkbox_list>
          </td>
          <td valign="middle" style="width: 20px; vertical-align: middle">
            <md-button
              style="display: none"
              class="md-behance md-just-icon md-round"
            >
              <md-icon>arrow_back</md-icon>
            </md-button>

            <md-button
              class="md-behance md-just-icon md-round"
              @click="fn_add('add')"
            >
              <md-icon>arrow_forward</md-icon>
            </md-button>
          </td>
          <td valign="top" style="vertical-align: top">
            <list_unidade_bycliente
              v-model="id_start_value"
              :onRemove="excluir"
            ></list_unidade_bycliente>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
 
<script>
import service from "../../../services/EstabelecimentoService";
import serviceCliente from "../../../services/ClienteService";

import checkbox_list from "../../components/checkbox_list";
import autocomplete from "../../../components/Rend/autocomplete";
import Util from "../../../library/Util";
//import vue_select from 'vue-select/src/components/Select.vue';
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import list_unidade_bycliente from "./list_unidade_bycliente";

export default {
  props: ["id_start_value"],
  components: {
    autocomplete: autocomplete,
    checkbox_list: checkbox_list,
    "vue-select": vue_select,
    list_unidade_bycliente: list_unidade_bycliente,
  },
  model: {
    prop: "id_start_value",
    event: "change_value",
  },
  data: function () {
    return {
      items: [],
      list_unidades: [],
      id_cliente: "",
      items_selected: [],

      loading: true,
      msg_status: "Carregando",
      disableButton: false,

      ids_unidades: "",

      show_unidades: false,
      loading_unidades: false,
    };
  },
  watch: {
    id_start_value: function (val) {
      if (
        this.id_start_value == null ||
        this.id_start_value == undefined ||
        this.id_start_value.toString() == ""
      ) {
        this.items_selected = [];
        return;
      }

      this.items_selected = this.id_start_value.toString().split(",");

      this.$emit("change_value", this.items_selected.join(","));
    },
  },
  methods: {
    selected_unidades(items) {
      //console.log("selected_unidades  ? " + items.join(",") );
      //this.ids_unidades = items.join(",");
    },

    fn_add(acao) {
      if (this.ids_unidades != "") {
        var ar = this.ids_unidades.toString().split(",");

        for (var i = 0; i < ar.length; i++) {
          if (ar[i] != "") {
            if (this.items_selected.indexOf(ar[i]) < 0) {
              this.items_selected.push(ar[i]);
            }
          }
        }

        var filtered = this.items_selected.filter(function (el) {
          return el != null && el != undefined && el != "";
        });

        this.$emit("change_value", filtered.join(","));
        this.ids_unidades = "";
      }
    },

    change_cliente(id_cliente) {
      var self = this;

      this.id_cliente = id_cliente;
      this.show_unidades = true;
      this.loading_unidades = true;
      //id_cliente
      if (
        this.id_cliente != null &&
        this.id_cliente != undefined &&
        this.id_cliente != ""
      ) {
        service
          .getListByParent("cliente", this.id_cliente)
          .then(function (response) {
            if (response.data != undefined) {
              self.list_unidades = response.data;
            } else {
              self.list_unidades = response;
            }
            //  self.show_unidades = true;
            self.loading_unidades = false;
            console.log("list_unidades?");
            console.log(response);
          });
      }else {
          
      this.show_unidades = false;
      this.loading_unidades = false;
      }
    },

    loadData() {
      var self = this;

      serviceCliente.getList2("", "nome", "asc").then(function (response) {
        self.items = Util.getListToSelect(response.data.data, "id", "nome");
        console.log(self.items);
      });
    },
    temEstaId(id) {
      if (
        this.id_start_value != null &&
        this.id_start_value != undefined &&
        this.id_start_value.toString() != ""
      ) {
        if (
          this.id_start_value.toString().split(",").indexOf(id.toString()) > -1
        ) {
          return true;
        }
      }

      return false;
    },
    fn_seleciona_todos() {
      if (this.seleciona_todos) {
        var ar = [];

        for (var i = 0; i < this.items.length; i++) {
          ar[i] = this.items[i][field_value];
        }

        this.items_selected = ar;
      } else {
      }
      this.items_selected = [];
    },

    seleciona(ev) {
      var valor = ev.target.value;
      var checked = ev.target.checked;

      if (this.items_selected.indexOf(valor.toString()) > -1) {
        //Já existe.

        if (!checked) {
          //Foi desmarcado..

          this.items_selected.splice(valor, 1);
        }
      } else {
        if (checked) {
          this.items_selected.push(valor);
        }
      }

      this.$emit("blur", this.items_selected.join(","));
      if (this.onSelect != null && this.onSelect != undefined) {
        this.onSelect(this.items_selected);
      }
    },
    add() {},
    excluir(item, index) {
      if (this.items_selected == undefined) {
        console.log("indefinido");
        console.log(this);
        return;
      }

      if (this.items_selected.indexOf(item.id.toString()) > -1) {
        var indx = this.items_selected.indexOf(item.id.toString());

        if (indx > -1) {
          this.items_selected.splice(indx, 1);
          console.log("chamei o deletar? " + indx);
          console.log(this.items_selected);
          this.$emit("change_value", this.items_selected.join(","));
        }
      }
    },
  },
  mounted() {
    console.log("add_unidades?? Sim? ");

    if (
      this.id_start_value == null ||
      this.id_start_value == undefined ||
      this.id_start_value.toString() == undefined
    ) {
        this.loading = false;
    this.loadData();
        return;
    }

    this.items_selected = this.id_start_value.toString().split(",");

    this.loadData();
  },
};
</script>                